rwgps = window.rwgps || {};

rwgps.BaseMap = function() {
}
rwgps.BaseMap.prototype = {
  setProvider: function(provider, map) {
    this.provider = provider;
    this.map = map;
    rwgps.Events.trigger("maps:provider:changed", provider, map)
  }
}



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/basemap.js